import Scene from './Scene';
import Game from '../Game';
import AudioSystem from '../System/Audio/AudioSystem';

export default class AudioScene extends Scene {
    public init(): void {
        this.addSystem(new AudioSystem(Game.store));

        this.systems.forEach(system => system.init());
    }
}
